import React, { useState, useRef } from "react";
import "./TagInput.css";
import { Tag, Input, Select } from "antd";

const baseInputWidth = 15;
const defaultInputWidth = 6;

const TagInput = (props) => {
  const [inputVal, setInputVal] = useState("");
  const [inputWidth, setInputWidth] = useState(defaultInputWidth);
  const { closable, log, validations, updateTags, tagList, clearTagErrors } =
    props;
  const tagInputRef = useRef(null);

  const closeTag = (value, index) => {
    //copy existing tags
    const newList = [...tagList];
    for (let x = 0; x < newList.length; x++) {
      if (newList[x].value === value && x === index) {
        //remove index
        newList.splice(x, 1);
        break;
      }
    }
    if (log) {
      console.log(value, newList);
    }

    //validate tags
    let errors = [];
    for (let x = 0; x < newList.length; x++) {
      newList[x].status = validations(newList[x].value, newList, x, errors);
    }

    updateTags(newList);
  };

  const createTag = (e) => {
    let value = e.target.value.trim();
    if (value.length > 0) {
      let newList = [...tagList];

      //split by , and \s map into array combine with existing tags
      newList = newList.concat(
        value.split(/[\s,]+/).reduce((accumilator, splittedMail) => {
          splittedMail = splittedMail.trim();
          if(splittedMail !== ""){
            accumilator.push({ value: splittedMail, status: true });
          }
          return accumilator;
        }, [])
      );

      //validate tags
      let errors = [];
      for (let x = 0; x < newList.length; x++) {
        newList[x].status = validations(newList[x].value, newList, x, errors);
      }

      if (log) {
        console.log(newList);
      }

      setInputVal("");
      setInputWidth(defaultInputWidth);
      updateTags(newList);
    }
  };

  const focusInput = () => {
    if (tagInputRef.current) {
      tagInputRef.current.focus();
    }
  };

  const onInputChange = (e) => {
    let val = e.target.value;
    setInputWidth(baseInputWidth + 8 * val.length);
    setInputVal(val.toLowerCase());
  };

  return (
    <div className="tagContainer" onClick={focusInput}>
      <Input className="hidden" value={tagList} />
      <div className="tagList">
        {tagList.map((tag, index) => {
          return (
            <Tag color={tag.status ? undefined : "red"}>
              {tag.value}
              {closable ? (
                <span
                  className="x"
                  onClick={() => {
                    clearTagErrors();
                    closeTag(tag.value, index);
                  }}
                >
                  x
                </span>
              ) : (
                <></>
              )}
            </Tag>
          );
        })}
        <Input
          className="tagInput"
          ref={tagInputRef}
          bordered={false}
          onPressEnter={createTag}
          onBlur={createTag}
          onChange={onInputChange}
          value={inputVal}
          style={{ width: inputWidth }}
        />
      </div>
    </div>
  );
};

export default TagInput;
